/* eslint-disable */

const internalLinkConf = () => {
  const linksIntern = document.querySelectorAll(".js-smooth-link");

  linksIntern.forEach(link => {
    link.addEventListener("click", function(e) {
        e.preventDefault();
    
        document.querySelector(this.getAttribute("href")).scrollIntoView({
          behavior: "smooth"
        });
      });
  })
};

export default internalLinkConf;
